export default "__VITE_ASSET__Bu88$G8L__"